// Look With Products component
class LookWithProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Find the image with reveal-on-scroll attribute
    const revealElement = this.querySelector('[reveal-on-scroll="true"]');

    if (revealElement) {
      // Check if we should apply animations based on user preferences
      const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // If reduced motion is preferred, make the image visible immediately
      if (prefersReducedMotion) {
        revealElement.style.opacity = '1';
        return;
      }

      // For users who don't prefer reduced motion, handle the animation
      // Use IntersectionObserver as a fallback if inView is not available
      if (window.inView) {
        window.inView(revealElement, ({ target }) => this.onBecameVisible(target), { margin: "-200px 0px 0px 0px" });
      } else {
        // Fallback to IntersectionObserver
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.onBecameVisible(entry.target);
              observer.unobserve(entry.target);
            }
          });
        }, { rootMargin: "-200px 0px 0px 0px", threshold: 0.1 });

        observer.observe(revealElement);
      }
    } else {
      // If there's no reveal element, make sure all images are visible
      const images = this.querySelectorAll('img');
      images.forEach(img => {
        img.style.opacity = '1';
      });
    }
  }

  async onBecameVisible(target) {
    // Wait for image to load if possible
    if (window.imageLoaded) {
      try {
        await window.imageLoaded(target);
      } catch (e) {
        console.log('Image load error:', e);
      }
    }

    // Calculate animation values
    const isRtl = window.direction === "rtl";
    const isMobile = window.matchesMediaQuery ? window.matchesMediaQuery("md-max") : window.innerWidth < 768;
    const isReverse = this.classList.contains("look-with-products--reverse");

    const fromValue = (isRtl ? -1 : 1) * (isMobile ? 0.6 : 1) * (isReverse ? 25 : -25);

    // Use the animate function if available, otherwise use basic CSS transitions
    if (window.animate) {
      window.animate(
        target,
        { opacity: 1, transform: [`translateX(${fromValue}px)`, "translateX(0)"] },
        { easing: [0.215, 0.61, 0.355, 1] },
        { duration: 0.8 }
      );
    } else {
      // Fallback animation using CSS transitions
      target.style.transition = 'opacity 0.8s ease, transform 0.8s cubic-bezier(0.215, 0.61, 0.355, 1)';
      target.style.opacity = '1';
      target.style.transform = 'translateX(0)';
    }
  }
}

// Register the custom element if it doesn't exist yet
if (typeof window !== 'undefined' && !window.customElements.get("look-with-products")) {
  window.customElements.define("look-with-products", LookWithProducts);
}
